const HorizontalLine = () => {
    return (
        <>
            <hr className="HorizontalLine" />
        </>
    );
};

export default HorizontalLine;
